import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, Optional } from '@angular/core';
import { AUTHENTICATION_CONFIG, AuthenticationConfig, AuthenticationService, IMenuProvider, Menu, SIDE_NAV_PROVIDER } from '@maersk-global/angular-shared-library';
import { concatAll, from, Observable, of, shareReplay } from 'rxjs';

@Component({
  selector: 'app-compact-sidemenubar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './compact-sidemenubar.component.html',
  styleUrl: './compact-sidemenubar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CompactSideMenuBarComponent {

  public menuList$?: Observable<Menu[]>;

  isHidden: boolean = true;

  constructor(
    @Inject(AUTHENTICATION_CONFIG)
    @Optional()
    private _authenticationConfig: AuthenticationConfig,
    @Optional() private _authenticationService: AuthenticationService,
    @Optional()
    @Inject(SIDE_NAV_PROVIDER)
    private readonly sideNavProvider: IMenuProvider[] | IMenuProvider,
  ) {
    this.setVisibilityState();
  }

  private setVisibilityState() {
    this.isHidden =
      this._authenticationConfig &&
      !this._authenticationService.isUserLoggedIn();
  }

  ngOnInit(): void {
    let menuListObservable$;
    if (Array.isArray(this.sideNavProvider)) {
      const menuObservableArray = from(
        this.sideNavProvider?.map((x) =>
          x.getMenu
            ? of(x.getMenu())
            : x.getMenuAsync
              ? x.getMenuAsync()
              : of([]),
        ),
      );
      menuListObservable$ = menuObservableArray.pipe(concatAll());
    } else {
      menuListObservable$ = this.sideNavProvider.getMenu
        ? of(this.sideNavProvider.getMenu())
        : this.sideNavProvider.getMenuAsync
          ? this.sideNavProvider.getMenuAsync()
          : of([]);
    }
    this.menuList$ = menuListObservable$.pipe(shareReplay());
  }

  async onMenuClick(selectedMenu: Menu, menuList: Menu[]) {
    menuList.forEach((menu) => {
      if (menu.displayName === selectedMenu.displayName) {
        menu.isSelected = true;
        menu.onClick?.();
      } else {
        menu.isSelected = false;
      }
    });
    this.menuList$ = of(menuList);
  }


}
